export default "__VITE_ASSET__Nliy24KW__"